module.exports = __webpack_public_path__ + "media/OPUS blir en del av TERRAVERA Business Program.4468be61.mp4";